/** AN0/AN1 — in-app notification bell (Admin only) */

export const NOTIFICATION_MAX_DROPDOWN_ITEMS = 10;

export const NOTIFICATION_ITEMS_PER_SECTION = 5;

/** SLA: topup/KYC submitted เกิน 24h → severity warning */
export const NOTIFICATION_SLA_HOURS = 24;

/** AN2 — เก็บประวัติใน bell / list */
export const NOTIFICATION_RETENTION_DAYS = 30;

/** AN3 — map section key → sidebar url สำหรับ badge */
export const NOTIFICATION_SIDEBAR_BADGE_ROUTES: Record<string, string> = {
  topup: "/app/wallet/topup",
  kyc: "/app/wallet/kyc-requests",
  suspicious: "/app/wallet/compliance",
};

const DEFAULT_POLL_MS = 30_000;

export function resolveNotificationPollMs(): number {
  // Optional build-time override. Read via `import.meta.env` with optional
  // chaining so it is safe in the browser bundle: neither `process` nor
  // `import.meta.env` is guaranteed to exist there, and an unset var must
  // resolve to `undefined` rather than throwing `process is not defined` /
  // a TypeError at runtime.
  const raw = import.meta.env?.PUBLIC_ADMIN_NOTIFICATION_POLL_MS;

  if (raw == null || raw === "") return DEFAULT_POLL_MS;
  const n = Number(raw);
  return Number.isFinite(n) && n >= 5_000 ? n : DEFAULT_POLL_MS;
}
